import React from 'react'
import SideBarLayout from "../../../layout/side-bar-layout"
import {TITLE_DESIGN_SYSTEM_PAGE} from "../../../../utils/constants"
import {Box} from "@mui/system"
import {Paper, Stack, Typography} from "@mui/material"
import TabsWrappedLabel from "../../../components/tabs/tabs-component"
import CodeViewer from "../../../components/CodeViewer/code-viewer"

const TabsPage = () => {
    const TITLE_PAGE = `${TITLE_DESIGN_SYSTEM_PAGE} | Tabs`

    const codeBasicUsage = `import TabsWrappedLabel from "../../../components/tabs/tabs-component"

<TabsWrappedLabel
   tabs={[
       {
           value: "1",
           label: "PRIMEIRA ABA",
           content: <><br/><Typography variant="body2" color="text.secondary" paragraph>{\`Conteúdo Aba 1\`}</Typography></>,
       },
       {
           value: "2",
           label: "SEGUNDA ABA",
           content: <><br/><Typography variant="body2" color="text.secondary" paragraph>{\`Conteúdo Aba 2\`}</Typography></>,
       },
       {
           value: "3",
           label: "TERCEIRA ABA",
           content: <><br/><Typography variant="body2" color="text.secondary" paragraph>{\`Conteúdo Aba 3\`}</Typography></>,
       },
       {
           value: "4",
           label: "QUARTA ABA",
           content: <><br/><Typography variant="body2" color="text.secondary" paragraph>{\`Conteúdo Aba 4\`}</Typography></>,
       },
   ]}
/>`

    const parametros = `
TabsWrappedLabel.propTypes = {
    tabs: PropTypes.arrayOf( // parâmetro tabs que recebe uma lista de dicionario com os dados abaixo
        PropTypes.shape({
            value: PropTypes.string.isRequired, // valor atribuido a aba (esse valor pode ser usado de forma dinâmica, automático após um evento)
            label: PropTypes.string.isRequired, // título da aba
            content: PropTypes.node, // componente que é passado para ser renderizado dentro da aba
        })
    ).isRequired,
}
`

    return <SideBarLayout
        header
        title={TITLE_PAGE}
        headerTitle={TITLE_PAGE}>

        <Box sx={{mt: -2}}>
            <Stack spacing={3}>
                <Paper>
                    <Box p={3}>
                        <Typography variant="h4" gutterBottom color="common.white">
                            {`Tabs`}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {`Componente de Tabs que controla visualização condicional de conteúdo por aba selecionada.`}
                        </Typography>

                        <Box mt={3}>
                            <Typography variant="h6" gutterBottom color="common.white">
                                {`Exemplo principal`}
                            </Typography>

                            <Typography variant="body2" color="text.secondary" paragraph>
                                {`Tabs simples`}
                            </Typography>

                            <TabsWrappedLabel
                                tabs={[
                                    {
                                        value: "1",
                                        label: "PRIMEIRA ABA",
                                        content: <><br/><Typography variant="body2" color="text.secondary"
                                                                    paragraph>{`Conteúdo Aba 1`}</Typography></>,
                                    },
                                    {
                                        value: "2",
                                        label: "SEGUNDA ABA",
                                        content: <><br/><Typography variant="body2" color="text.secondary"
                                                                    paragraph>{`Conteúdo Aba 2`}</Typography></>,
                                    },
                                    {
                                        value: "3",
                                        label: "TERCEIRA ABA",
                                        content: <><br/><Typography variant="body2" color="text.secondary"
                                                                    paragraph>{`Conteúdo Aba 3`}</Typography></>,
                                    },
                                    {
                                        value: "4",
                                        label: "QUARTA ABA",
                                        content: <><br/><Typography variant="body2" color="text.secondary"
                                                                    paragraph>{`Conteúdo Aba 4`}</Typography></>,
                                    },
                                ]}
                            />
                        </Box>

                    </Box>
                </Paper>

                <Paper>
                    <Box p={3}>
                        <Typography variant="h6" gutterBottom color="common.white">
                            {`Uso básico`}
                        </Typography>

                        <Typography variant="body2" color="text.secondary" paragraph>
                            {`Abaixo um exemplo mínimo de configuração para utilizar as abas.`}
                        </Typography>

                        <Paper variant="outlined">
                            <Box p={2}>
                                <CodeViewer code={codeBasicUsage} language="jsx"/>
                            </Box>
                        </Paper>
                    </Box>
                </Paper>
                <Paper>
                    <Box p={3}>
                        <Typography variant="h6" gutterBottom color="common.white">
                            {`Parâmetros`}
                        </Typography>

                        <Paper variant="outlined">
                            <Box p={2}>
                                <CodeViewer code={parametros} language="jsx"/>
                            </Box>
                        </Paper>
                    </Box>
                </Paper>
            </Stack>
        </Box>
    </SideBarLayout>
}

export default TabsPage